import type { ReactNode } from 'react';
import { Button } from './Button';
import { buttonClass } from './buttonClass';
import s from './ui.module.css';

export interface ErrorNoticeProps {
  /** Что случилось — одной фразой. */
  readonly what: string;
  /** Почему — простыми словами. */
  readonly why: string;
  /** Что сделать сейчас: кнопка-действие или ссылка. */
  readonly action: { readonly label: string; readonly onClick?: () => void; readonly href?: string };
  /** Второе, тихое действие рядом с главным (например, «Всё равно открыть» у предупреждения). */
  readonly secondary?: { readonly label: string; readonly onClick: () => void };
  /** Как избежать в следующий раз (необязательно). */
  readonly avoid?: ReactNode;
}

/** Главное правило Chat: ошибка никогда не оставляет человека в подвешенном состоянии. */
export function ErrorNotice({ what, why, action, secondary, avoid }: ErrorNoticeProps) {
  return (
    <div className={[s.alert, s.alertError, s.errorNotice].join(' ')} role="alert">
      <strong className={s.errorNoticeWhat}>{what}</strong>
      <span>{why}</span>
      {avoid !== undefined && <span className={s.errorNoticeAvoid}>{avoid}</span>}
      <div className={s.errorNoticeActions}>
        {action.href === undefined ? (
          <Button variant="secondary" size="small" onClick={action.onClick}>{action.label}</Button>
        ) : (
          <a className={buttonClass({ variant: 'secondary', size: 'small' })} href={action.href}>{action.label}</a>
        )}
        {secondary !== undefined && (
          <Button variant="ghost" size="small" onClick={secondary.onClick}>{secondary.label}</Button>
        )}
      </div>
    </div>
  );
}
